import { createApi } from '@reduxjs/toolkit/query/react';

import { apiUserFeedback } from '~constants/api';

import { Response, rtkBaseQueryWrapper } from '~libs/axiosWrapper';

type WorkflowType = 'sah-claims-wizard' | string;

interface CreateUserFeedbackRequest {
  workflow_type: WorkflowType;
  rating: 'positive' | 'negative';
  comment?: string;
}

export const userFeedbackApi = createApi({
  reducerPath: 'userFeedbackApi',
  baseQuery: rtkBaseQueryWrapper({ baseUrl: apiUserFeedback }),
  tagTypes: ['userFeedback'],
  endpoints: (builder) => ({
    createUserFeedback: builder.mutation<Response<null>, CreateUserFeedbackRequest>({
      query: (body) => ({ url: '', method: 'POST', body }),
    }),
  }),
});

export const { useCreateUserFeedbackMutation } = userFeedbackApi;
